import { Constants } from "appConstants";
import favicon from "assets/icons/favicon.png";
import EulaModal, { EulaSections } from "components/EulaModal";
import { motion } from "framer-motion";
import { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { SelectType, SignUpForm } from "./modules";

export default function SignUp() {
	const { user } = useSelector((state: RootState) => state.auth);
	const [isCompany, setIsCompany] = useState<boolean>(user?.documentType === Constants.UserDocumentType.CNPJ);
	const [typeSelected, setTypeSelected] = useState<boolean>(!!user?.documentType);
	const [isEulaModalOpen, setIsEulaModalOpen] = useState<boolean>(false);
	const [selectedEulaSection, setSelectedEulaSection] = useState<EulaSections>(EulaSections.COOKIES);

	const initialX = useMemo(() => (user?.document ? "-50%" : "0%"), [user]);

	return (
		<>
			<Helmet>
				<title>{`${process.env.REACT_APP_TITLE} - Cadastro`}</title>
				<link rel="shortcut icon" href={favicon} type="image/x-icon" />
				<link rel="icon" href={favicon} type="image/x-icon" />
			</Helmet>
			<div className="w-full h-full flex justify-center">
				<div
					className={`w-[100vw] sm:w-[31rem] my-10 overflow-hidden transition-all duration-500 rounded-lg flex ${
						typeSelected ? "max-h-[64rem] sm:max-h-[62rem]" : "max-h-[32rem] sm:max-h-[28rem]"
					}`}
				>
					<motion.div
						initial={{ x: initialX }}
						animate={typeSelected ? "hide" : "show"}
						variants={{
							show: {
								x: 0,
								transition: {
									ease: "easeOut",
									duration: 0.3
								}
							},
							hide: {
								x: "-50%"
							}
						}}
						transition={{
							ease: "easeInOut",
							duration: user?.documentType ? false : 0.2
						}}
						className="flex"
					>
						<SelectType
							setIsCompany={(value) => {
								setTypeSelected(true);
								setIsCompany(value);
							}}
						/>
						<div>
							<SignUpForm
								isCompany={isCompany}
								onGoBack={() => {
									setTypeSelected(false);
								}}
								hideGoBack={!!user?.documentType}
								setSelectedEulaSection={(newSection) => {
									setSelectedEulaSection(newSection);
									setIsEulaModalOpen(true);
								}}
							/>
						</div>
					</motion.div>
				</div>
			</div>
			<EulaModal displayedPolicy={selectedEulaSection} isOpen={isEulaModalOpen} onClose={() => setIsEulaModalOpen(false)} />
		</>
	);
}
